import { render } from "./UserCourseSelectionView.vue?vue&type=template&id=7813e017"
import script from "./UserCourseSelectionView.vue?vue&type=script&lang=js"
export * from "./UserCourseSelectionView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__